<template>
  <div class="card" style="min-height:273px;">
    <div class="card-header text-center">
      <slot name="header">
        <h5 class="card-title capitalize" style="min-height:60px">{{formatTitle(title)}}</h5>
        <p class="card-category" v-if="description">{{description}}</p>
      </slot>
    </div>
    <div class="card-body">
      <doughnut-chart :data="chartData"
                      :labels="labels"
                      :height="150"
                      :secondary-color="secondaryColor"
                      :color="chartColor">
      </doughnut-chart>
    </div>
    <!--<div class="card-footer">-->
      <!--<button type="button" @click="requeue" class="btn btn-fill btn-info btn-wd">Requeue Messages</button>-->
    <!--</div>-->
  </div>
</template>
<script>
  import DoughnutChart from '../Charts/DoughnutChart'

  export default {
    name: 'queue-count-card',
    components: {
      DoughnutChart,
    },
    props: {
      secondaryColor: {
        type: String,
        default: '#f4f3ef',
        description: 'Secondary color'
      },
      total: {
        type: Number,
        default: 0,
        description: 'Total things'
      },
      title: {
        type: String,
        description: 'Chart card title'
      },
      description: {
        type: String,
        description: 'Chart card description'
      },
      labels: {
        type: Array,
        default: () => {
          return [1, 2]
        },
        description: 'Labels for each chart section'
      }
    },
    computed: {
      chartData() {
        return [this.total]
      },
      chartColor() {
        let color = 'green'
        if (this.total <= 10) {
          color = 'yellow'
        } else if (this.total < 100) {
          color = 'orange'
        } else if (this.total >= 100) {
          color = 'red'
        }
        return color
      }
    },
    methods: {
      formatTitle(title) {
        if (title.startsWith('ptrac')) {
          title = title.substr(6, title.length)
        }

        return title.replace(/_/g, ' ')
      },
      requeue () {
        this.$eventHub.$emit('show-modal-1', 'Requeue', {name: this.title, count: this.total}, '400px')
      }
    }
  }
</script>
<style scoped>
  .capitalize {
    text-transform:capitalize;
  }
</style>
